module.exports = __webpack_public_path__ + "img/nav-right-with-contact-lincoln.a0e87ccd.png";